import { REACT_APP_ONBOARDING_API, REACT_APP_X_API_KEY } from '../env';
import { Envs } from '../utils/typeHelpers/envs';
import { getAccessToken } from './sendbird.api';

export class UnauthorizedError extends Error {
  constructor(message = 'Não autorizado.') {
    super(message);
    this.name = 'UnauthorizedError';
    Object.setPrototypeOf(this, UnauthorizedError.prototype);
  }
}

export interface UserSearch {
  id: number;
  name: string;
  profileUrl: string;
  email?: boolean;
  company: string;
}

export interface UserSearchResponse {
  currentPage: number;
  data: UserSearch[];
  total: number;
  totalPages: number;
}

export async function searchUsers({
  page = 1,
  size = 100,
  query = '',
  envs
}: {
  page?: number;
  size?: number;
  query?: string;
  envs: Envs
}): Promise<UserSearchResponse> {
  const params = new URLSearchParams({
    page: String(page),
    size: String(size),
  });
  if (query && query !== '') params.append('query', query);

  const token = envs.accessToken ? (await envs.accessToken!()) : (envs.token || getAccessToken());
  const accountId = envs.accountId || localStorage.getItem("chat-account-id");
  const xApiKey = envs.xApiKey || REACT_APP_X_API_KEY;
    const onboardindApiUrl = envs.onboardindApiUrl || REACT_APP_ONBOARDING_API;

  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
    'X-Api-Key': xApiKey as string,
    'X-Account-Id': accountId as string
  }
  
  const url = `${onboardindApiUrl}/chat-users?${params.toString()}`;
  const response = await fetch(url, {
    method: 'GET',
    headers
  });
  if (response.status === 401) {
    throw new UnauthorizedError();
  }
  if (!response.ok) {
    throw new Error('Erro ao buscar usuários.');
  }
  const data = await response.json();
  return {
    currentPage: data.page,
    data: data.data.map((user: any) => ({
      id: user.id,
      name: user.name,
      profileUrl: user.profileUrl,
      company: user.company,
    })),
    total: data.total,
    totalPages: Math.ceil(data.total / (data.pageSize || 1)),
  };
}

